/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.162.0-v202607291944-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqFoldersApiClass {
 
   constructor() {}

  /**
   * @summary Archive a folder and all of its content
   * @param {string} folderId - ID of the folder to archive
  */
  public archiveFolder(
    {
      folderId
    } : {
      folderId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (folderId === null || folderId === undefined) {
      throw new Error("'folderId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/${encodeURIComponent(String(folderId))}`
      .replace('{folderId}', encodeURIComponent(String(folderId)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a folder
  */
  public createFolder(
    body: models.FolderInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.FolderOutputV1>;
  }

  /**
   * @summary Get navigation context for a folder. 
   * @param {string} folderId - ID of the folder to retrieve.
   * @param {string} [root] - What sharing category results should be returned for
  */
  public getAncestors(
    {
      folderId,
      root
    } : {
      folderId: string,
      root?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (folderId === null || folderId === undefined) {
      throw new Error("'folderId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/${encodeURIComponent(String(folderId))}/ancestors`
      .replace('{folderId}', encodeURIComponent(String(folderId)));

    const queryParams = {
      ['root']: root
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.FolderNavigationOutputV1>;
  }

  /**
   * @summary Get information about a folder
   * @param {string} folderId - ID of the folder to retrieve. Special values: &#x27;mine&#x27; for the authenticated user&#x27;s Home folder; &#x27;corporate&#x27; for the Corporate folder; &#x27;externallyShared&#x27; for the Externally Shared folder; &#x27;users&#x27; (admins only) for the folder that contains the home folders of all users.
   * @param {boolean} [fullAncestry] - If true, the full ancestry  will be returned, which includes the home folder of the relevant user. Otherwise, the home folder is not returned. Requires admin privileges.
  */
  public getFolder(
    {
      folderId,
      fullAncestry
    } : {
      folderId: string,
      fullAncestry?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (folderId === null || folderId === undefined) {
      throw new Error("'folderId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/${encodeURIComponent(String(folderId))}`
      .replace('{folderId}', encodeURIComponent(String(folderId)));

    const queryParams = {
      ['fullAncestry']: fullAncestry
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.FolderOutputV1>;
  }

  /**
   * @summary Search and get all root folders and workbooks, or folder content if a parent folder id is specified. Note: This endpoint can be slow when filtering by shared items, or searching by text. If you don't need to filter or search, consider using the navigateFolders endpoint instead, which is optimized for speed.
   * @param {string} [filter=all] - If set to &#x27;mine&#x27; or &#x27;owner&#x27;, only workbench items under the current user&#x27;s home folder will be returned. If set to &#x27;public&#x27; only workbench items shared with the Everyone group will be returned, excluding items under the corporate folder. If set to &#x27;sharedOrPublic&#x27; only workbench items shared with the current user or a group they belong to are returned, excluding items under the corporate folder. If set to &#x27;sharedDirectlyWithMe&#x27; only workbench items directly shared with the current user will be returned, excluding items under the corporate folder and items shared with groups the user belongs to. If set to &#x27;shared&#x27; only workbench items shared with the current user or a group they belong to (except the Everyone group) are returned, excluding items under the corporate folder. If set to &#x27;corporate&#x27;, only workbench items under the corporate folder are returned. If set to &#x27;users&#x27;, only items under other user&#x27;s home folders are returned. If set to &#x27;all&#x27; (or not specified), all workbench items the current user has access to will be returned.
   * @param {string} [userId] - The user ID to return folders for, defaults to the current user if not specified. Only an admin user is allowed to specify a user ID.
   * @param {boolean} [isArchived=false] - When true, returns only archived workbench items.
   * @param {string} [sortOrder=createdAt asc] - One or two fields by which to order the folders. Each field is followed by a space and &#x27;asc&#x27; or &#x27;desc&#x27;. Multiple fields are comma-separated. Field names can be one of: createdAt, updatedAt, openedAt, name, owner, creator, relevance. Example: name asc, openedAt desc
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [onlyPinned=false] - When true, returns only pinned workbench items are returned. The given folderId is not applied.
   * @param {string} [folderId] - The folder to return the content of. If not specified, only root folders are returned unless filtering to specific IDs, filtering to pinned or archived items, sorting by last opened timestamp, or a text search is provided.
   * @param {Array<string>} [ids] - The IDs of items to return.
   * @param {Array<string>} [types] - The types of items to return.
   * @param {string} [textSearch] - Search text by which to filter items&#x27; names.
   * @param {boolean} [isExact=false] - If true, uses the exact query terms supplied by the user instead of stemming the query to its root words
   * @param {string} [root] - The highest ancestor that items should have, if possible
   * @param {Array<string>} [searchFields] - Search by name, description, or document body.  Searches name by default when no field is supplied
   * @param {Array<string>} [creatorIds] - List of creator IDs to filter on
   * @param {Array<string>} [ownerIds] - List of owner IDs to filter on
   * @param {Array<string>} [locations] - List of locations to search under, may be &#x27;mine&#x27;, &#x27;others&#x27;, or &#x27;corporate&#x27;. &#x27;mine&#x27; searches all items under the current user&#x27;s home folder. &#x27;others&#x27; searches items under home folders belonging to all users other than the current user. &#x27;corporate&#x27; searches the corporate folder, if enabled. Values may be used together. No values searches all locations.
   * @param {Array<string>} [accessStatuses] - List of access statuses to search by, may be &#x27;public&#x27;, &#x27;groups&#x27;, or &#x27;directly&#x27;. &#x27;public&#x27; searches items shared with the Everyone group, if enabled. &#x27;groups&#x27; searches items shared with groups the current user belongs to. &#x27;directly&#x27; searches items directly accessible by the current user. No values searches all access statuses.
  */
  public getFolders(
    {
      filter,
      userId,
      isArchived,
      sortOrder,
      offset,
      limit,
      onlyPinned,
      folderId,
      ids,
      types,
      textSearch,
      isExact,
      root,
      searchFields,
      creatorIds,
      ownerIds,
      locations,
      accessStatuses
    } : {
      filter?: FilterEnum,
      userId?: string,
      isArchived?: boolean,
      sortOrder?: string,
      offset?: number,
      limit?: number,
      onlyPinned?: boolean,
      folderId?: string,
      ids?: Array<string>,
      types?: Array<string>,
      textSearch?: string,
      isExact?: boolean,
      root?: RootEnum,
      searchFields?: SearchFieldsEnum[],
      creatorIds?: Array<string>,
      ownerIds?: Array<string>,
      locations?: LocationsEnum[],
      accessStatuses?: AccessStatusesEnum[]
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders`;

    const queryParams = {
      ['filter']: filter,      ['userId']: userId,      ['isArchived']: isArchived,      ['sortOrder']: sortOrder,      ['offset']: offset,      ['limit']: limit,      ['onlyPinned']: onlyPinned,      ['folderId']: folderId,      ['ids']: ids,      ['types']: types,      ['textSearch']: textSearch,      ['isExact']: isExact,      ['root']: root,      ['searchFields']: searchFields,      ['creatorIds']: creatorIds,      ['ownerIds']: ownerIds,      ['locations']: locations,      ['accessStatuses']: accessStatuses
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.WorkbenchItemOutputListV1>;
  }

  /**
   * @summary Get pinned home screen items for the current user. This method is deprecated; use GET /folders/navigateFolders with onlyPinned=true instead.
   * @deprecated Use GET /folders/navigateFolders with onlyPinned&#x3D;true.
  */
  public getPinned(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/pinned`;



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.FolderSearchResultsV1>;
  }

  /**
   * @summary Get recently used home screen items for the current user. The results will be ordered in descending order (most recently used first, least recently used last). This method is deprecated; use GET /folders/navigateFolders sorted by openedAt desc instead.
   * @param {number} [limit=10] - The maximum number of recently used home screen items to return. Default is 10, maximum is 100.
   * @deprecated Use GET /folders/navigateFolders sorted by openedAt desc.
  */
  public getRecentlyUsed(
    {
      limit
    } : {
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/recentlyUsed`;

    const queryParams = {
      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.FolderSearchResultsV1>;
  }

  /**
   * @summary Get subfolders of a folder. This endpoint is a much improved version of the v1 /subfolders endpoint that is now deprecated and should be able to be used as a direct replacement.
   * @param {string} folderId - ID of the folder to retrieve. Special values of &#x27;mine&#x27;, &#x27;corporate&#x27;, &#x27;externallyShared&#x27;, or &#x27;users&#x27; can be used to fetch the top level categories.NOTE: The sharedOrPublic filter should use GET /folders/search.
  */
  public getSimpleSubfolders(
    {
      folderId
    } : {
      folderId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (folderId === null || folderId === undefined) {
      throw new Error("'folderId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/${encodeURIComponent(String(folderId))}/simpleSubfolders`
      .replace('{folderId}', encodeURIComponent(String(folderId)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.FolderNavigationOutputV1>;
  }

  /**
   * @summary Get subfolders of a folder. 
   * @param {string} folderId - ID of the folder to retrieve. Special values of &#x27;mine&#x27;, &#x27;corporate&#x27;, &#x27;sharedOrPublic&#x27;, &#x27;externallyShared&#x27;, or &#x27;users&#x27; can be used to fetch the top level categories.
   * @param {string} [root] - What sharing category results should be returned for
  */
  public getSubfolders(
    {
      folderId,
      root
    } : {
      folderId: string,
      root?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (folderId === null || folderId === undefined) {
      throw new Error("'folderId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/${encodeURIComponent(String(folderId))}/subfolders`
      .replace('{folderId}', encodeURIComponent(String(folderId)));

    const queryParams = {
      ['root']: root
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.FolderNavigationOutputV1>;
  }

  /**
   * @summary Move specified item to specified folder
   * @param {string} folderId - ID of folder to move item to. Special values of &#x27;mine&#x27; or &#x27;corporate&#x27; move the item to the authenticated user&#x27;s home folder or the corporate folder, respectively.
   * @param {string} itemId - ID of item to move to folder
  */
  public moveItemToFolder(
    {
      folderId,
      itemId
    } : {
      folderId: string,
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (folderId === null || folderId === undefined) {
      throw new Error("'folderId' parameter required");
    }

    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/${encodeURIComponent(String(folderId))}/${encodeURIComponent(String(itemId))}`
      .replace('{folderId}', encodeURIComponent(String(folderId)))
      .replace('{itemId}', encodeURIComponent(String(itemId)));



    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<models.FolderOutputV1>;
  }

  /**
   * @summary Get all root folders and workbooks, or folder content if a parent folder id is specified. This endpoint is experimental and may change in future releases.
   * @param {boolean} [isArchived=false] - When true, returns only archived workbench items.
   * @param {string} [sortOrder=createdAt asc] - One or two fields by which to order the folders. Each field is followed by a space and &#x27;asc&#x27; or &#x27;desc&#x27;. Multiple fields are comma-separated. Field names can be one of: createdAt, updatedAt, openedAt, name, owner, creator. If openedAt is included, the given folderId is not applied. Example: name asc, openedAt desc
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [onlyPinned=false] - When true, returns only pinned workbench items are returned. The given folderId is not applied.
   * @param {string} [folderId] - The folder to return the content of. If not specified, only root folders are returned unless filtering to specific IDs, filtering to pinned or archived items, sorting by last opened timestamp, or a text search is provided.
   * @param {string} [root] - The root workbench location this navigation is being shown under. When provided, this takes precedence over inferred admin-specific breadcrumb routing.
   * @param {Array<string>} [types] - The types of items to return.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public navigateFolders(
    {
      isArchived,
      sortOrder,
      offset,
      limit,
      onlyPinned,
      folderId,
      root,
      types
    } : {
      isArchived?: boolean,
      sortOrder?: string,
      offset?: number,
      limit?: number,
      onlyPinned?: boolean,
      folderId?: string,
      root?: string,
      types?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/navigateFolders`;

    const queryParams = {
      ['isArchived']: isArchived,      ['sortOrder']: sortOrder,      ['offset']: offset,      ['limit']: limit,      ['onlyPinned']: onlyPinned,      ['folderId']: folderId,      ['root']: root,      ['types']: types
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.WorkbenchItemOutputListV1>;
  }

  /**
   * @summary Remove specified item from specified folder. The item will be moved to the root level.
   * @param {string} folderId - ID of folder to remove item from
   * @param {string} itemId - ID of item to remove from folder
  */
  public removeItemFromFolder(
    {
      folderId,
      itemId
    } : {
      folderId: string,
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (folderId === null || folderId === undefined) {
      throw new Error("'folderId' parameter required");
    }

    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/${encodeURIComponent(String(folderId))}/${encodeURIComponent(String(itemId))}`
      .replace('{folderId}', encodeURIComponent(String(folderId)))
      .replace('{itemId}', encodeURIComponent(String(itemId)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.FolderOutputV1>;
  }

  /**
   * @summary Search for folder content using string fragments and filters. This search is FAST, but it is also 'eventually consistent,' meaning that data that was written to the database may take some time to propagate to this search facility. Results will be returned based on read access to the content. If you are an admin, all results will be returned. 
   * @param {string} [query] - String fragment to search for. Text will be matched against the content of the folder(s). If the &#x27;query&#x27; argument is not supplied, all items are returned (that match the &#x27;filter&#x27;, &#x27;location&#x27; and &#x27;parentFolderId&#x27; arguments, if provided). 
   * @param {string} [filter] - The filter string to apply to the search.&lt;br&gt; &lt;br&gt; Examples: &lt;pre&gt;&#x27;Type&#x27; &#x3D; &#x27;Analysis&#x27; AND Owner &#x3D; &#x27;768C213D-F50E-40AC-AA68-D7D6BB09916E&#x27;&lt;/pre&gt;&lt;br&gt; You can use &#x27;AND&#x27;, &#x27;OR&#x27;, and &#x27;NOT&#x27; to combine multiple filters, using parentheses to group them if necessary.&lt;br&gt; &lt;br&gt; For the &lt;strong&gt;Created At&lt;/strong&gt; and &lt;strong&gt;Updated At&lt;/strong&gt; fields, which are millisecond-based UNIX timestamps, you can use &amp;gt; and &amp;lt; operators.&lt;br&gt; &lt;br&gt; For the &lt;strong&gt;Ancestors&lt;/strong&gt;, &lt;strong&gt;AclRead&lt;/strong&gt;, &lt;strong&gt;AclWrite&lt;/strong&gt;, and &lt;strong&gt;AclManage&lt;/strong&gt; fields, which are lists of IDs, hits will be returned if any members of the list match the filter.&lt;br&gt; &lt;br&gt; You can only filter on indexed fields, which are:&lt;br&gt; &lt;ul&gt;     &lt;li&gt;&lt;strong&gt;Type&lt;/strong&gt; (&#x27;Folder&#x27;, &#x27;Analysis&#x27;, &#x27;Topic&#x27; etc)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;Created At&lt;/strong&gt; (nanosecond-based UNIX timestamp)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;Updated At&lt;/strong&gt; (nanosecond-based UNIX timestamp)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;Owner&lt;/strong&gt; (user ID)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;Archived&lt;/strong&gt; (true/false)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;Ancestors&lt;/strong&gt; (list of folder IDs in ascending order from top, with top-level of __Users__ or __Corporate__)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;AclRead&lt;/strong&gt; (list of identity IDs that have read access to the content)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;AclWrite&lt;/strong&gt; (list of identity IDs that have write access to the content)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;AclManage&lt;/strong&gt; (list of identity IDs that have manage access to the content)&lt;/li&gt; &lt;/ul&gt; 
   * @param {string} [location=ALL] - Determines the location(s) to search for items. It acts as a convenient shortcut for applying multiple filters. The following locations are supported: &lt;br&gt; &lt;ul&gt;     &lt;li&gt;&lt;strong&gt;ALL&lt;/strong&gt; (Searches all locations for non-archived items)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;MINE&lt;/strong&gt; (Searches for non-archived items in the current users home folder)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;SHARED&lt;/strong&gt; (Searches for non-archived items shared with the current user)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;SHARED_EXTERNALLY&lt;/strong&gt; (Searches for non-archived items that are shared externally)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;CORPORATE&lt;/strong&gt; (Searches for non-archived items in the corporate folder)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;USERS&lt;/strong&gt; (Searches for non-archived items in the users folder)&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;TRASH&lt;/strong&gt; (Searches for archived items/items in the trash)&lt;/li&gt; &lt;/ul&gt; Leaving the parameter empty searches all locations (similar to &#x27;ALL&#x27;). 
   * @param {string} [parentFolderId] - ID of a folder to limit the search to. If supplied, only items within this folder (and its subfolders) will be searched. 
   * @param {string} [sortField] - Field to sort the results by. Supported fields are:&lt;br&gt; &lt;ul&gt;     &lt;li&gt;&lt;strong&gt;Name&lt;/strong&gt;&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;Created At&lt;/strong&gt;&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;Updated At&lt;/strong&gt;&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;Creator&lt;/strong&gt;&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;Owner&lt;/strong&gt;&lt;/li&gt; &lt;/ul&gt; Leave this parameter empty to use the default sorting (relevance). 
   * @param {string} [sortOrder=ASC] - Sort order for the results. Supported values are:&lt;br&gt; &lt;ul&gt;     &lt;li&gt;&lt;strong&gt;ASC&lt;/strong&gt; for ascending&lt;/li&gt;     &lt;li&gt;&lt;strong&gt;DESC&lt;/strong&gt; for descending&lt;/li&gt; &lt;/ul&gt; 
   * @param {string} [hitHighlightFormat] - If supplied, this turns on &lt;em&gt;hit highlighting&lt;/em&gt; for the search results, which identifies the words that were matched in the content. The value is a string in the following format: &lt;pre&gt;&amp;lt;strong&amp;gt;%s&amp;lt;/strong&amp;gt;&lt;/pre&gt; In this example, we&#x27;re putting the hit highlight (the placeholder is &lt;strong&gt;%s&lt;/strong&gt;) in a &amp;lt;strong&amp;gt; HTML tag. You can replace this string with whatever makes sense for your purposes.&lt;br&gt; &lt;br&gt; If you do not specify this parameter, then no hit highlighting is performed.&lt;br&gt; &lt;br&gt; Highlights are returned in the \&quot;Highlights\&quot; key of each hit. 
   * @param {number} [hitsPerPage=40] - Number of hits to return per page. Defaults to 40.
   * @param {number} [page=1] - One-based page number to retrieve. If zero is specified, then no hits are returned -- only the hit counts. 
  */
  public search(
    {
      query,
      filter,
      location,
      parentFolderId,
      sortField,
      sortOrder,
      hitHighlightFormat,
      hitsPerPage,
      page
    } : {
      query?: string,
      filter?: string,
      location?: LocationEnum,
      parentFolderId?: string,
      sortField?: SortFieldEnum,
      sortOrder?: SortOrderEnum,
      hitHighlightFormat?: string,
      hitsPerPage?: number,
      page?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/folders/search`;

    const queryParams = {
      ['query']: query,      ['filter']: filter,      ['location']: location,      ['parentFolderId']: parentFolderId,      ['sortField']: sortField,      ['sortOrder']: sortOrder,      ['hitHighlightFormat']: hitHighlightFormat,      ['hitsPerPage']: hitsPerPage,      ['page']: page
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.FolderSearchResultsV1>;
  }

}

export const FilterEnum = {
    Mine: 'Mine',
    Owner: 'Owner',
    Public: 'Public',
    SharedOrPublic: 'SharedOrPublic',
    SharedDirectlyWithMe: 'SharedDirectlyWithMe',
    Shared: 'Shared',
    Corporate: 'Corporate',
    Users: 'Users',
    All: 'All',
    ExternallyShared: 'ExternallyShared'
} as const;

export type FilterEnum = typeof FilterEnum[keyof typeof FilterEnum];
export const RootEnum = {
    Mine: 'Mine',
    Shared: 'Shared',
    Corporate: 'Corporate',
    Users: 'Users',
    ExternallyShared: 'ExternallyShared'
} as const;

export type RootEnum = typeof RootEnum[keyof typeof RootEnum];
export const SearchFieldsEnum = {
    All: 'All',
    Name: 'Name',
    Description: 'Description',
    Document: 'Document'
} as const;

export type SearchFieldsEnum = typeof SearchFieldsEnum[keyof typeof SearchFieldsEnum];
export const LocationsEnum = {
    Mine: 'Mine',
    Others: 'Others',
    Corporate: 'Corporate',
    ExternallyShared: 'ExternallyShared'
} as const;

export type LocationsEnum = typeof LocationsEnum[keyof typeof LocationsEnum];
export const AccessStatusesEnum = {
    Public: 'Public',
    Groups: 'Groups',
    Directly: 'Directly'
} as const;

export type AccessStatusesEnum = typeof AccessStatusesEnum[keyof typeof AccessStatusesEnum];
export const LocationEnum = {
    ALL: 'ALL',
    MINE: 'MINE',
    SHARED: 'SHARED',
    SHAREDEXTERNALLY: 'SHARED_EXTERNALLY',
    CORPORATE: 'CORPORATE',
    USERS: 'USERS',
    EXTERNALLYSHARED: 'EXTERNALLY_SHARED',
    TRASH: 'TRASH'
} as const;

export type LocationEnum = typeof LocationEnum[keyof typeof LocationEnum];
export const SortFieldEnum = {
    Name: 'Name',
    CreatedAt: 'CreatedAt',
    UpdatedAt: 'UpdatedAt',
    Creator: 'Creator',
    Owner: 'Owner'
} as const;

export type SortFieldEnum = typeof SortFieldEnum[keyof typeof SortFieldEnum];
export const SortOrderEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderEnum = typeof SortOrderEnum[keyof typeof SortOrderEnum];

export const sqFoldersApi = new sqFoldersApiClass();

export type sqFoldersApiEndpoints = {
  'archiveFolder': {
    method: 'delete';
    path: '/folders/${encodeURIComponent(String(folderId))}';
    response: models.ArchiveOutputV1;
  };
  'createFolder': {
    method: 'post';
    path: '/folders';
    response: models.FolderOutputV1;
  };
  'getAncestors': {
    method: 'get';
    path: '/folders/${encodeURIComponent(String(folderId))}/ancestors';
    response: models.FolderNavigationOutputV1;
  };
  'getFolder': {
    method: 'get';
    path: '/folders/${encodeURIComponent(String(folderId))}';
    response: models.FolderOutputV1;
  };
  'getFolders': {
    method: 'get';
    path: '/folders';
    response: models.WorkbenchItemOutputListV1;
  };
  'getPinned': {
    method: 'get';
    path: '/folders/pinned';
    response: models.FolderSearchResultsV1;
  };
  'getRecentlyUsed': {
    method: 'get';
    path: '/folders/recentlyUsed';
    response: models.FolderSearchResultsV1;
  };
  'getSimpleSubfolders': {
    method: 'get';
    path: '/folders/${encodeURIComponent(String(folderId))}/simpleSubfolders';
    response: models.FolderNavigationOutputV1;
  };
  'getSubfolders': {
    method: 'get';
    path: '/folders/${encodeURIComponent(String(folderId))}/subfolders';
    response: models.FolderNavigationOutputV1;
  };
  'moveItemToFolder': {
    method: 'post';
    path: '/folders/${encodeURIComponent(String(folderId))}/${encodeURIComponent(String(itemId))}';
    response: models.FolderOutputV1;
  };
  'navigateFolders': {
    method: 'get';
    path: '/folders/navigateFolders';
    response: models.WorkbenchItemOutputListV1;
  };
  'removeItemFromFolder': {
    method: 'delete';
    path: '/folders/${encodeURIComponent(String(folderId))}/${encodeURIComponent(String(itemId))}';
    response: models.FolderOutputV1;
  };
  'search': {
    method: 'get';
    path: '/folders/search';
    response: models.FolderSearchResultsV1;
  };
};

type ApiArchiveFolderResponse = models.ArchiveOutputV1;
type ApiarchiveFolderMutationParams = Parameters<typeof sqFoldersApi.archiveFolder> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFoldersApi.archiveFolder>;

export function useApiArchiveFolderMutation(
  options?: Omit<UseMutationOptions<ApiArchiveFolderResponse, AxiosError<SeeqErrorData>,
    ApiarchiveFolderMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveFolderResponse, AxiosError<SeeqErrorData>,
  ApiarchiveFolderMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveFolderMutationParams) =>
      sqFoldersApi.archiveFolder(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateFolderResponse = models.FolderOutputV1;
type ApicreateFolderMutationParams = Parameters<typeof sqFoldersApi.createFolder> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFoldersApi.createFolder>;
type ApicreateFolderMutationVariables = models.FolderInputV1;

export function useApiCreateFolderMutation(
  options?: Omit<UseMutationOptions<ApiCreateFolderResponse, AxiosError<SeeqErrorData>,
    ApicreateFolderMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateFolderResponse, AxiosError<SeeqErrorData>,
  ApicreateFolderMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateFolderMutationVariables) =>
      sqFoldersApi.createFolder(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetAncestorsResponse = models.FolderNavigationOutputV1;
export function GetAncestorsQueryKey(
  params: Parameters<typeof sqFoldersApi.getAncestors>[0],
) {
  return ['sqFoldersApi', 'getAncestors', params] as const;
}

export function useApiGetAncestorsQuery(
  params: Parameters<typeof sqFoldersApi.getAncestors>[0],
  options?: Omit<UseQueryOptions<ApiGetAncestorsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAncestorsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAncestorsQueryKey(params),
    queryFn: () =>
      sqFoldersApi.getAncestors(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetFolderResponse = models.FolderOutputV1;
export function GetFolderQueryKey(
  params: Parameters<typeof sqFoldersApi.getFolder>[0],
) {
  return ['sqFoldersApi', 'getFolder', params] as const;
}

export function useApiGetFolderQuery(
  params: Parameters<typeof sqFoldersApi.getFolder>[0],
  options?: Omit<UseQueryOptions<ApiGetFolderResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetFolderResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetFolderQueryKey(params),
    queryFn: () =>
      sqFoldersApi.getFolder(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetFoldersResponse = models.WorkbenchItemOutputListV1;
export function GetFoldersQueryKey(
  params: Parameters<typeof sqFoldersApi.getFolders>[0],
) {
  return ['sqFoldersApi', 'getFolders', params] as const;
}

export function useApiGetFoldersQuery(
  params: Parameters<typeof sqFoldersApi.getFolders>[0],
  options?: Omit<UseQueryOptions<ApiGetFoldersResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetFoldersResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetFoldersQueryKey(params),
    queryFn: () =>
      sqFoldersApi.getFolders(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetPinnedResponse = models.FolderSearchResultsV1;
export function GetPinnedQueryKey(
) {
  return ['sqFoldersApi', 'getPinned'] as const;
}

export function useApiGetPinnedQuery(
  options?: Omit<UseQueryOptions<ApiGetPinnedResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetPinnedResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetPinnedQueryKey(),
    queryFn: () =>
      sqFoldersApi.getPinned(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetRecentlyUsedResponse = models.FolderSearchResultsV1;
export function GetRecentlyUsedQueryKey(
  params: Parameters<typeof sqFoldersApi.getRecentlyUsed>[0],
) {
  return ['sqFoldersApi', 'getRecentlyUsed', params] as const;
}

export function useApiGetRecentlyUsedQuery(
  params: Parameters<typeof sqFoldersApi.getRecentlyUsed>[0],
  options?: Omit<UseQueryOptions<ApiGetRecentlyUsedResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetRecentlyUsedResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetRecentlyUsedQueryKey(params),
    queryFn: () =>
      sqFoldersApi.getRecentlyUsed(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSimpleSubfoldersResponse = models.FolderNavigationOutputV1;
export function GetSimpleSubfoldersQueryKey(
  params: Parameters<typeof sqFoldersApi.getSimpleSubfolders>[0],
) {
  return ['sqFoldersApi', 'getSimpleSubfolders', params] as const;
}

export function useApiGetSimpleSubfoldersQuery(
  params: Parameters<typeof sqFoldersApi.getSimpleSubfolders>[0],
  options?: Omit<UseQueryOptions<ApiGetSimpleSubfoldersResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetSimpleSubfoldersResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetSimpleSubfoldersQueryKey(params),
    queryFn: () =>
      sqFoldersApi.getSimpleSubfolders(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSubfoldersResponse = models.FolderNavigationOutputV1;
export function GetSubfoldersQueryKey(
  params: Parameters<typeof sqFoldersApi.getSubfolders>[0],
) {
  return ['sqFoldersApi', 'getSubfolders', params] as const;
}

export function useApiGetSubfoldersQuery(
  params: Parameters<typeof sqFoldersApi.getSubfolders>[0],
  options?: Omit<UseQueryOptions<ApiGetSubfoldersResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetSubfoldersResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetSubfoldersQueryKey(params),
    queryFn: () =>
      sqFoldersApi.getSubfolders(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiMoveItemToFolderResponse = models.FolderOutputV1;
type ApimoveItemToFolderMutationParams = Parameters<typeof sqFoldersApi.moveItemToFolder> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFoldersApi.moveItemToFolder>;

export function useApiMoveItemToFolderMutation(
  options?: Omit<UseMutationOptions<ApiMoveItemToFolderResponse, AxiosError<SeeqErrorData>,
    ApimoveItemToFolderMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiMoveItemToFolderResponse, AxiosError<SeeqErrorData>,
  ApimoveItemToFolderMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApimoveItemToFolderMutationParams) =>
      sqFoldersApi.moveItemToFolder(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiNavigateFoldersResponse = models.WorkbenchItemOutputListV1;
export function NavigateFoldersQueryKey(
  params: Parameters<typeof sqFoldersApi.navigateFolders>[0],
) {
  return ['sqFoldersApi', 'navigateFolders', params] as const;
}

export function useApiNavigateFoldersQuery(
  params: Parameters<typeof sqFoldersApi.navigateFolders>[0],
  options?: Omit<UseQueryOptions<ApiNavigateFoldersResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiNavigateFoldersResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: NavigateFoldersQueryKey(params),
    queryFn: () =>
      sqFoldersApi.navigateFolders(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiRemoveItemFromFolderResponse = models.FolderOutputV1;
type ApiremoveItemFromFolderMutationParams = Parameters<typeof sqFoldersApi.removeItemFromFolder> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFoldersApi.removeItemFromFolder>;

export function useApiRemoveItemFromFolderMutation(
  options?: Omit<UseMutationOptions<ApiRemoveItemFromFolderResponse, AxiosError<SeeqErrorData>,
    ApiremoveItemFromFolderMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRemoveItemFromFolderResponse, AxiosError<SeeqErrorData>,
  ApiremoveItemFromFolderMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiremoveItemFromFolderMutationParams) =>
      sqFoldersApi.removeItemFromFolder(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSearchResponse = models.FolderSearchResultsV1;
export function SearchQueryKey(
  params: Parameters<typeof sqFoldersApi.search>[0],
) {
  return ['sqFoldersApi', 'search', params] as const;
}

export function useApiSearchQuery(
  params: Parameters<typeof sqFoldersApi.search>[0],
  options?: Omit<UseQueryOptions<ApiSearchResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiSearchResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: SearchQueryKey(params),
    queryFn: () =>
      sqFoldersApi.search(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
